/**
 * Onboarding wizard — multi-step UI + Google Sheets submission.
 */
(function () {
  "use strict";

  var TOTAL = 6;
  var current = 1;
  var selectedPackageId = "brand";
  var selectedPackage = "Brand Launch";

  var PACKAGE_LABELS = {
    starter: "Launch Starter",
    brand: "Brand Launch",
    full: "Full Launch",
  };
  var transitioning = false;
  var isSubmitting = false;
  var submitSucceeded = false;

  var panelsWrap = document.getElementById("onboardPanels");
  var panels = document.querySelectorAll(".onboard-panel");
  var pills = document.querySelectorAll(".onboard-step-pill");
  var progressFill = document.getElementById("progressFill");
  var progressBar = document.querySelector(".onboard-progress-bar");
  var stepCurrent = document.getElementById("stepCurrent");
  var btnPrev = document.getElementById("btnPrev");
  var btnNext = document.getElementById("btnNext");
  var btnSubmit = document.getElementById("btnSubmit");
  var actionsNote = document.getElementById("actionsNote");
  var pkgs = document.querySelectorAll(".onboard-pkg");
  var checkoutSelected = document.getElementById("checkoutSelected");

  var stepNotes = {
    1: "خطوتك التالية: رفع الملفات",
    2: "خطوتك التالية: الملاحظات والمراجع",
    3: "خطوتك التالية: شرح خطوات العمل",
    4: "خطوتك التالية: بيانات التواصل",
    5: "خطوتك التالية: اختيار الباقة وتأكيد الطلب",
    6: "اختر باقتك ثم أرسل الطلب",
  };

  var WEBHOOK_URL =
    "https://script.google.com/macros/s/AKfycbwNbVhVejtON1QbEs0jr2Xdibdj6ZTRzJXywS9CE6B1rJim4b36SxsvPy7eaFgrSa1t/exec";

  var pkgData = {
    starter: {
      name: "Launch Starter",
      price: "4,999",
      timeline: "7–14 يوم",
      desc: "تصميم الهوم بيدج + براندينج أساسي + ZIP للرفع",
    },
    brand: {
      name: "Brand Launch",
      price: "6,999",
      timeline: "7–14 يوم",
      desc: "إعداد كامل على Shopify من طرفنا",
    },
    full: {
      name: "Full Launch",
      price: "11,999",
      timeline: "10–18 يوم",
      desc: "Done-for-you — منتجات، أوصاف، وتسعير",
    },
  };

  function getPanel(n) {
    return document.querySelector('.onboard-panel[data-panel="' + n + '"]');
  }

  function progressOffset() {
    var nav = document.querySelector(".onboard-nav");
    var prog = document.querySelector(".onboard-progress");
    return (nav ? nav.offsetHeight : 0) + (prog ? prog.offsetHeight : 0);
  }

  function setPanelHeight(panel) {
    if (!panelsWrap || !panel) return;
    var h = panel.scrollHeight || panel.offsetHeight;
    if (h > 0) panelsWrap.style.minHeight = h + "px";
  }

  function showPanelReveals(panel) {
    if (!panel) return;
    panel.querySelectorAll(".reveal").forEach(function (el) {
      el.classList.add("in");
    });
  }

  function updateProgress() {
    var pct = (current / TOTAL) * 100;
    if (progressFill) progressFill.style.width = pct + "%";
    if (progressBar) {
      progressBar.setAttribute("aria-valuenow", String(current));
      progressBar.setAttribute("aria-valuemax", String(TOTAL));
    }
    if (stepCurrent) stepCurrent.textContent = String(current);

    pills.forEach(function (pill) {
      var n = parseInt(pill.getAttribute("data-step"), 10);
      pill.classList.remove("is-active", "is-done");
      pill.setAttribute("aria-current", "false");
      if (n === current) {
        pill.classList.add("is-active");
        pill.setAttribute("aria-current", "step");
      } else if (n < current) {
        pill.classList.add("is-done");
      }
    });
  }

  function updateFooter() {
    var isFirst = current === 1;
    var isLast = current === TOTAL;

    if (btnPrev) {
      btnPrev.disabled = isFirst || transitioning;
      btnPrev.hidden = isFirst;
    }

    if (actionsNote) {
      actionsNote.textContent = stepNotes[current] || "";
    }

    if (btnNext) {
      btnNext.style.display = isLast ? "none" : "inline-flex";
      btnNext.disabled = transitioning;
    }

    if (btnSubmit) {
      btnSubmit.style.display = isLast && !submitSucceeded ? "inline-flex" : "none";
      btnSubmit.disabled = transitioning || isSubmitting || !selectedPackageId;
    }
  }

  function escapeSelector(id) {
    if (typeof CSS !== "undefined" && CSS.escape) {
      return CSS.escape(id);
    }
    return String(id).replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, "\\$1");
  }

  function getWebhookUrl() {
    var cfg = window.ONBOARDING_CONFIG || {};
    var url = (cfg.submitUrl || WEBHOOK_URL || "").trim();
    return url || WEBHOOK_URL;
  }

  function getSubmitSecret() {
    var cfg = window.ONBOARDING_CONFIG || {};
    return (cfg.submitSecret || "").trim();
  }

  var formState = {};

  var FORM_FIELD_IDS = [
    "brandName",
    "brandSlogan",
    "productCategory",
    "brandColors",
    "targetAudience",
    "communicationStyle",
    "brandStory",
    "teamNotes",
    "productDetails",
    "instagram",
    "favoriteWebsites",
    "fullName",
    "phone",
    "email",
    "city",
  ];

  function isDebug() {
    var cfg = window.ONBOARDING_CONFIG || {};
    return cfg.debug === true;
  }

  function readElementValue(el) {
    if (!el) return "";
    if (el.type === "checkbox") return el.checked ? "yes" : "";
    if (el.type === "radio" && !el.checked) return "";
    var v = el.value;
    return v != null ? String(v).trim() : "";
  }

  function findField(id) {
    var el = document.getElementById(id);
    if (el) return el;
    var root = document.getElementById("onboardPanels");
    if (root) el = root.querySelector("#" + escapeSelector(id));
    return el || null;
  }

  function fieldVal(id) {
    var el = findField(id);
    var value = readElementValue(el);
    formState[id] = value;
    return value;
  }

  function syncAllFormFields() {
    var i;
    for (i = 0; i < FORM_FIELD_IDS.length; i++) {
      var id = FORM_FIELD_IDS[i];
      var el = findField(id);
      if (el) formState[id] = readElementValue(el);
    }
  }

  function initFormPersistence() {
    var root = document.getElementById("onboardPanels");
    if (!root) return;

    function capture(e) {
      var t = e.target;
      if (!t || !t.id) return;
      if (
        t.tagName === "INPUT" ||
        t.tagName === "TEXTAREA" ||
        t.tagName === "SELECT"
      ) {
        formState[t.id] = readElementValue(t);
      }
    }

    root.addEventListener("input", capture, true);
    root.addEventListener("change", capture, true);
    syncAllFormFields();
  }

  function formatFilesValue(names, placeholder) {
    if (names && names.length) return names.join(", ");
    return placeholder || "لم يُرفع";
  }

  function logFormSnapshot(label) {
    if (!isDebug()) return;
    syncAllFormFields();
    console.log("[Onboarding] " + label, buildSubmissionPayload({
      logoFiles: [],
      productImageFiles: [],
      referenceImageFiles: [],
    }));
  }

  function getUploadFiles(type) {
    var zone = document.querySelector('.onboard-drop[data-upload="' + type + '"]');
    if (!zone || !zone._uploadFiles) return [];
    return zone._uploadFiles.slice();
  }

  function fileNamesList(type) {
    return getUploadFiles(type).map(function (f) {
      return f.name;
    });
  }

  function getPreviewUrls(type) {
    var zone = document.querySelector('.onboard-drop[data-upload="' + type + '"]');
    if (!zone || !zone._previewUrls) return [];
    return zone._previewUrls.slice();
  }

  function joinUrls(urls, placeholder) {
    if (urls && urls.length) return urls.join("\n");
    return placeholder || "";
  }

  function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var result = reader.result || "";
        resolve({
          fileName: file.name,
          mimeType: file.type || "application/octet-stream",
          base64Data: String(result).split(",")[1] || "",
        });
      };
      reader.onerror = function () {
        reject(reader.error || new Error("File read failed"));
      };
      reader.readAsDataURL(file);
    });
  }

  function encodeAllUploadFiles() {
    var logoFiles = getUploadFiles("logo");
    var productFiles = getUploadFiles("products");
    var refFiles = getUploadFiles("refs");

    if (!logoFiles.length && !productFiles.length && !refFiles.length) {
      return Promise.resolve({
        logoFiles: [],
        productImageFiles: [],
        referenceImageFiles: [],
      });
    }

    return Promise.all([
      Promise.all(logoFiles.map(fileToBase64)),
      Promise.all(productFiles.map(fileToBase64)),
      Promise.all(refFiles.map(fileToBase64)),
    ]).then(function (groups) {
      return {
        logoFiles: groups[0],
        productImageFiles: groups[1],
        referenceImageFiles: groups[2],
      };
    });
  }

  function summarizeFilesForLog(list) {
    return (list || []).map(function (f) {
      return {
        fileName: f.fileName,
        mimeType: f.mimeType,
        bytes: f.base64Data ? f.base64Data.length : 0,
      };
    });
  }

  function payloadForLog(payload) {
    var copy = {};
    var key;
    for (key in payload) {
      if (!Object.prototype.hasOwnProperty.call(payload, key)) continue;
      if (key === "logoFiles") {
        copy.logoFiles = summarizeFilesForLog(payload.logoFiles);
      } else if (key === "productImageFiles") {
        copy.productImageFiles = summarizeFilesForLog(payload.productImageFiles);
      } else if (key === "referenceImageFiles") {
        copy.referenceImageFiles = summarizeFilesForLog(payload.referenceImageFiles);
      } else {
        copy[key] = payload[key];
      }
    }
    return copy;
  }

  function syncPackageHiddenInputs() {
    var idEl = document.getElementById("selectedPackageId");
    var labelEl = document.getElementById("selectedPackage");
    if (idEl) idEl.value = selectedPackageId || "";
    if (labelEl) labelEl.value = selectedPackage || "";
  }

  function syncPackageFromDom() {
    var card = document.querySelector(".onboard-pkg.is-selected[data-pkg]");
    if (card) {
      var id = card.getAttribute("data-pkg");
      if (id && pkgData[id]) {
        selectedPackageId = id;
        selectedPackage = PACKAGE_LABELS[id] || pkgData[id].name || id;
      }
    } else {
      var idInput = document.getElementById("selectedPackageId");
      if (idInput && idInput.value && pkgData[idInput.value]) {
        selectedPackageId = idInput.value;
        selectedPackage =
          PACKAGE_LABELS[selectedPackageId] ||
          (pkgData[selectedPackageId] && pkgData[selectedPackageId].name) ||
          selectedPackageId;
      }
    }
    syncPackageHiddenInputs();
    return selectedPackage;
  }

  function getSelectedPackageLabel(withPrice) {
    syncPackageFromDom();
    var label = selectedPackage || PACKAGE_LABELS[selectedPackageId] || "";
    if (!withPrice) return label;
    var pkg = pkgData[selectedPackageId] || {};
    if (pkg.price) {
      return label + " (" + pkg.price + " ج.م)";
    }
    return label;
  }

  function buildSubmissionPayload(encodedFiles) {
    syncAllFormFields();
    syncPackageFromDom();

    encodedFiles = encodedFiles || {
      logoFiles: [],
      productImageFiles: [],
      referenceImageFiles: [],
    };

    var payload = {
      timestamp: new Date().toISOString(),
      brandName: fieldVal("brandName"),
      brandSlogan: fieldVal("brandSlogan"),
      productCategory: fieldVal("productCategory"),
      brandColors: fieldVal("brandColors"),
      targetAudience: fieldVal("targetAudience"),
      communicationStyle: fieldVal("communicationStyle"),
      brandStory: fieldVal("brandStory"),
      instagram: fieldVal("instagram"),
      favoriteWebsites: fieldVal("favoriteWebsites"),
      teamNotes: fieldVal("teamNotes"),
      productDetails: fieldVal("productDetails"),
      fullName: fieldVal("fullName"),
      phone: fieldVal("phone"),
      email: fieldVal("email"),
      city: fieldVal("city"),
      selectedPackage: selectedPackage,
      logoFiles: encodedFiles.logoFiles || [],
      productImageFiles: encodedFiles.productImageFiles || [],
      referenceImageFiles: encodedFiles.referenceImageFiles || [],
    };

    var secret = getSubmitSecret();
    if (secret) payload.secret = secret;

    return payload;
  }

  function postToWebhook(webhookUrl, payload) {
    return fetch(webhookUrl, {
      method: "POST",
      mode: "no-cors",
      body: JSON.stringify(payload),
    });
  }

  function emptyEncodedFiles() {
    return {
      logoFiles: [],
      productImageFiles: [],
      referenceImageFiles: [],
    };
  }

  function validateSubmission() {
    syncPackageFromDom();
    var errors = [];
    if (!fieldVal("brandName")) errors.push("اسم البراند مطلوب");
    if (!fieldVal("fullName")) errors.push("الاسم الكامل مطلوب");
    if (!fieldVal("phone")) errors.push("رقم الموبايل / واتساب مطلوب");
    if (!selectedPackageId || !selectedPackage) {
      errors.push("اختر باقة قبل الإرسال");
    }
    return errors;
  }

  function showSubmitError(message) {
    var el = document.getElementById("onboardSubmitError");
    if (!el) {
      alert(message);
      return;
    }
    el.textContent = message;
    el.hidden = false;
    el.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function clearSubmitError() {
    var el = document.getElementById("onboardSubmitError");
    if (el) el.hidden = true;
  }

  function setSubmitLoading(loading) {
    isSubmitting = loading;
    if (!btnSubmit) return;
    btnSubmit.classList.toggle("is-loading", loading);
    if (loading) {
      btnSubmit.disabled = true;
      btnSubmit.innerHTML =
        '<span class="onboard-spinner" aria-hidden="true"></span> جاري الإرسال...';
    } else if (!submitSucceeded) {
      btnSubmit.disabled = !selectedPackageId;
      btnSubmit.innerHTML =
        'إرسال الطلب <svg class="arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>';
    }
    updateFooter();
  }

  function showSuccessScreen() {
    submitSucceeded = true;
    document.body.classList.add("onboard-submitted");

    var success = document.getElementById("onboardSuccess");
    if (success) {
      success.hidden = false;
      success.setAttribute("aria-hidden", "false");
    }

    var actions = document.querySelector(".onboard-actions");
    if (actions) actions.hidden = true;

    var progress = document.querySelector(".onboard-progress");
    if (progress) progress.hidden = true;

    panels.forEach(function (panel) {
      panel.hidden = true;
      panel.classList.remove("is-active");
    });

    if (panelsWrap) panelsWrap.style.minHeight = "";

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function submitOnboarding(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (isSubmitting || submitSucceeded) {
      return;
    }

    clearSubmitError();

    var errors = validateSubmission();
    if (errors.length) {
      showSubmitError(errors[0]);
      if (errors[0].indexOf("براند") !== -1) goTo(1);
      else if (errors[0].indexOf("الاسم") !== -1 || errors[0].indexOf("موبايل") !== -1)
        goTo(5);
      else if (errors[0].indexOf("باقة") !== -1) goTo(6);
      return;
    }

    var webhookUrl = getWebhookUrl();
    setSubmitLoading(true);
    syncAllFormFields();

    encodeAllUploadFiles()
      .catch(function (fileErr) {
        if (typeof console !== "undefined" && console.warn) {
          console.warn(
            "[Onboarding] File encode failed — submitting text fields only",
            fileErr
          );
        }
        return emptyEncodedFiles();
      })
      .then(function (encodedFiles) {
        syncPackageFromDom();
        var payload = buildSubmissionPayload(encodedFiles);

        console.log("FINAL PAYLOAD", payloadForLog(payload));
        console.log("WEBHOOK URL", webhookUrl);

        return postToWebhook(webhookUrl, payload);
      })
      .then(function () {
        console.log("WEBHOOK SENT SUCCESSFULLY");
        setSubmitLoading(false);
        showSuccessScreen();
      })
      .catch(function (err) {
        setSubmitLoading(false);
        if (typeof console !== "undefined" && console.error) {
          console.error("[Onboarding] Submit failed:", err);
        }
        showSubmitError(
          (err && err.message) ||
            "تعذّر إرسال الطلب. تحقق من الاتصال وحاول مرة أخرى."
        );
      });
  }

  function animateReveal(panel) {
    if (!panel) return;
    var els = panel.querySelectorAll(".reveal");
    var i;
    for (i = 0; i < els.length; i++) {
      els[i].classList.remove("in");
    }
    requestAnimationFrame(function () {
      for (i = 0; i < els.length; i++) {
        (function (el, delay) {
          setTimeout(function () {
            el.classList.add("in");
          }, delay);
        })(els[i], 40 + i * 45);
      }
    });
  }

  function applyStepVisibility() {
    var i;
    for (i = 0; i < panels.length; i++) {
      var panel = panels[i];
      var step = parseInt(panel.getAttribute("data-panel"), 10) || i + 1;
      var active = step === current;
      panel.hidden = !active;
      panel.classList.toggle("is-active", active);
      panel.classList.remove("is-leaving", "is-entering");
      if (active) showPanelReveals(panel);
    }
  }

  function goTo(step) {
    step = Math.max(1, Math.min(TOTAL, step));
    if (step === current || transitioning) return;

    var prevPanel = getPanel(current);
    var nextPanel = getPanel(step);
    if (!nextPanel) return;

    transitioning = true;
    updateFooter();

    if (prevPanel) {
      prevPanel.classList.add("is-leaving");
    }

    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var delay = reduced ? 0 : 280;

    setTimeout(function () {
      if (prevPanel) {
        prevPanel.classList.remove("is-leaving", "is-active");
        prevPanel.hidden = true;
      }

      nextPanel.hidden = false;
      nextPanel.classList.add("is-active", "is-entering");

      current = step;
      updateProgress();
      updateFooter();

      if (current === TOTAL) {
        updateCheckoutSummary();
        updateCheckoutSelected();
      }

      requestAnimationFrame(function () {
        nextPanel.classList.remove("is-entering");
        setPanelHeight(nextPanel);
        animateReveal(nextPanel);
      });

      transitioning = false;
      updateFooter();
      logFormSnapshot("after step " + current);

      window.scrollTo({
        top: progressOffset(),
        behavior: reduced ? "auto" : "smooth",
      });
    }, delay);
  }

  function selectPkg(el) {
    if (!el) return;
    var id = el.getAttribute("data-pkg");
    if (!id || !pkgData[id]) return;

    selectedPackageId = id;
    selectedPackage = PACKAGE_LABELS[id] || pkgData[id].name || id;

    pkgs.forEach(function (p) {
      var on = p === el;
      p.classList.toggle("is-selected", on);
      p.setAttribute("aria-checked", on ? "true" : "false");
    });
    el.classList.remove("is-pulse");
    void el.offsetWidth;
    el.classList.add("is-pulse");
    setTimeout(function () {
      el.classList.remove("is-pulse");
    }, 520);

    syncPackageHiddenInputs();
    updateCheckoutSelected();
    if (btnSubmit && current === TOTAL) {
      btnSubmit.disabled = !selectedPackageId;
    }
  }

  function updateCheckoutSelected() {
    var d = pkgData[selectedPackageId];
    if (!checkoutSelected || !d) return;
    checkoutSelected.innerHTML =
      '<p class="checkout-selected-label">باقتك المختارة</p>' +
      '<p class="checkout-selected-name">' +
      d.name +
      "</p>" +
      '<p class="checkout-selected-price">' +
      d.price +
      ' <small>ج.م</small></p>' +
      '<p class="checkout-selected-desc">' +
      d.desc +
      "</p>";
    checkoutSelected.classList.add("is-visible");
  }

  function updateCheckoutSummary() {
    var brand = document.getElementById("brandName");
    var cat = document.getElementById("productCategory");
    var name = document.getElementById("fullName");
    var phone = document.getElementById("phone");

    function set(id, val) {
      var el = document.getElementById(id);
      if (el) el.textContent = val || "—";
    }

    set("sumBrand", brand && brand.value.trim());
    set("sumCategory", cat && cat.value);
    set("sumContact", name && name.value.trim());
    set("sumPhone", phone && phone.value.trim());

    var d = pkgData[selectedPackageId];
    set("sumTimeline", d ? d.timeline : "7–14 يوم");
  }

  function initUploads() {
    var zones = document.querySelectorAll(".onboard-drop[data-upload]");
    if (!zones.length) return;

    var configs = {
      logo: { multiple: false, maxFiles: 1, maxSize: 5 * 1024 * 1024 },
      products: { multiple: true, maxFiles: 20, maxSize: 10 * 1024 * 1024 },
      refs: { multiple: true, maxFiles: 20, maxSize: 10 * 1024 * 1024 },
    };

    function formatSize(bytes) {
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    }

    function isImage(file) {
      return file.type.indexOf("image/") === 0;
    }

    function setupZone(zone) {
      var type = zone.getAttribute("data-upload");
      var cfg = configs[type];
      if (!cfg) return;

      var input = zone.querySelector(".onboard-drop-input");
      var preview = zone.querySelector(".onboard-drop-preview");
      var status = zone.querySelector(".onboard-drop-status");
      if (!input || !preview) return;

      var files = [];
      zone._uploadFiles = [];
      var urls = [];
      var dragCounter = 0;

      function setStatus(msg) {
        if (!status) return;
        status.textContent = msg;
        status.hidden = !msg;
      }

      function flashSuccess(msg) {
        zone.classList.add("is-success");
        setStatus(msg);
        setTimeout(function () {
          zone.classList.remove("is-success");
        }, 1600);
      }

      function revokePreviewUrl(url) {
        if (url) {
          try {
            URL.revokeObjectURL(url);
          } catch (e) {
            /* ignore */
          }
        }
      }

      function revokeAll() {
        urls.forEach(revokePreviewUrl);
        urls = [];
        zone._previewUrls = [];
      }

      function syncInput() {
        if (typeof DataTransfer === "undefined") return;
        try {
          var dt = new DataTransfer();
          files.forEach(function (f) {
            dt.items.add(f);
          });
          input.files = dt.files;
        } catch (e) {
          /* DataTransfer unsupported — previews still work */
        }
      }

      function render() {
        preview.innerHTML = "";
        zone._previewUrls = [];
        urls = [];

        files.forEach(function (file, index) {
          var thumb = document.createElement("div");
          thumb.className = "onboard-drop-thumb";
          var url = null;

          if (isImage(file)) {
            if (file._blobUrl) {
              url = file._blobUrl;
            } else {
              url = URL.createObjectURL(file);
              file._blobUrl = url;
            }
            urls.push(url);
            zone._previewUrls.push(url);
            var img = document.createElement("img");
            img.src = url;
            img.alt = file.name;
            thumb.appendChild(img);
          } else {
            thumb.classList.add("is-file");
            var label = document.createElement("span");
            label.textContent = file.name;
            thumb.appendChild(label);
          }

          var remove = document.createElement("button");
          remove.type = "button";
          remove.className = "onboard-drop-remove";
          remove.setAttribute("aria-label", "حذف " + file.name);
          remove.textContent = "\u00d7";
          remove.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var removed = files.splice(index, 1)[0];
            if (removed && removed._blobUrl) {
              revokePreviewUrl(removed._blobUrl);
              removed._blobUrl = null;
            }
            render();
          });
          thumb.appendChild(remove);
          preview.appendChild(thumb);
        });

        var has = files.length > 0;
        zone._uploadFiles = files.slice();
        zone.classList.toggle("has-files", has);
        preview.hidden = !has;
        syncInput();

        if (has) {
          var label =
            files.length === 1
              ? "\u2713 تم رفع الملف"
              : "\u2713 تم رفع " + files.length + " ملفات";
          setStatus(label);
        } else {
          setStatus("");
        }

        if (current === 2) {
          setPanelHeight(getPanel(2));
        }
      }

      function addFiles(fileList) {
        var incoming = Array.prototype.slice.call(fileList || []);
        if (!incoming.length) return;

        var accepted = [];
        var i;
        for (i = 0; i < incoming.length; i++) {
          var file = incoming[i];
          if (!isImage(file) && type === "logo") continue;
          if (!isImage(file) && type !== "logo") continue;
          if (file.size > cfg.maxSize) {
            setStatus(
              "الملف " + file.name + " أكبر من " + formatSize(cfg.maxSize)
            );
            continue;
          }
          accepted.push(file);
        }

        if (!accepted.length) return;

        if (cfg.multiple) {
          var room = cfg.maxFiles - files.length;
          if (room <= 0) {
            setStatus("الحد الأقصى " + cfg.maxFiles + " ملف");
            return;
          }
          files = files.concat(accepted.slice(0, room));
        } else {
          if (files[0] && files[0]._blobUrl) {
            revokePreviewUrl(files[0]._blobUrl);
            files[0]._blobUrl = null;
          }
          files = [accepted[0]];
        }

        render();
        flashSuccess(
          files.length === 1
            ? "\u2713 تم الرفع بنجاح"
            : "\u2713 تم رفع " + files.length + " ملفات"
        );
      }

      function openPicker() {
        input.click();
      }

      zone.addEventListener("click", function (e) {
        if (e.target.closest(".onboard-drop-remove")) return;
        openPicker();
      });

      zone.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openPicker();
        }
      });

      input.addEventListener("change", function () {
        addFiles(input.files);
      });

      zone.addEventListener("dragenter", function (e) {
        e.preventDefault();
        dragCounter += 1;
        zone.classList.add("is-dragover");
      });

      zone.addEventListener("dragover", function (e) {
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = "copy";
      });

      zone.addEventListener("dragleave", function (e) {
        e.preventDefault();
        dragCounter -= 1;
        if (dragCounter <= 0) {
          dragCounter = 0;
          zone.classList.remove("is-dragover");
        }
      });

      zone.addEventListener("drop", function (e) {
        e.preventDefault();
        dragCounter = 0;
        zone.classList.remove("is-dragover");
        addFiles(e.dataTransfer && e.dataTransfer.files);
      });
    }

    zones.forEach(setupZone);
  }

  function bindEvents() {
    initFormPersistence();
    initUploads();

    var pkgGrid = document.querySelector(".onboard-pkg-grid--checkout");
    if (pkgGrid) {
      pkgGrid.addEventListener("click", function (e) {
        var card = e.target.closest(".onboard-pkg[data-pkg]");
        if (card) selectPkg(card);
      });
      pkgGrid.addEventListener("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        var card = e.target.closest(".onboard-pkg[data-pkg]");
        if (!card) return;
        e.preventDefault();
        selectPkg(card);
      });
    }

    if (btnPrev) {
      btnPrev.addEventListener("click", function () {
        goTo(current - 1);
      });
    }

    if (btnNext) {
      btnNext.addEventListener("click", function () {
        goTo(current + 1);
      });
    }

    document.addEventListener("click", function (e) {
      if (!e.target.closest("#btnSubmit, .onboard-btn-submit")) return;
      submitOnboarding(e);
    });

    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        var n = parseInt(pill.getAttribute("data-step"), 10);
        if (n <= current) goTo(n);
      });
    });

    window.addEventListener(
      "resize",
      function () {
        setPanelHeight(getPanel(current));
      },
      false
    );
  }

  function init() {
    panels = document.querySelectorAll(".onboard-panel");
    panelsWrap = document.getElementById("onboardPanels");
    btnSubmit = document.getElementById("btnSubmit");
    btnNext = document.getElementById("btnNext");
    btnPrev = document.getElementById("btnPrev");
    pkgs = document.querySelectorAll(".onboard-pkg[data-pkg]");
    checkoutSelected = document.getElementById("checkoutSelected");

    if (!panels.length) {
      console.error("[Onboarding] No panels found — submit disabled");
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var pkgParam = params.get("pkg");
    if (pkgParam && pkgData[pkgParam]) {
      var match = document.querySelector(
        '.onboard-pkg[data-pkg="' + pkgParam + '"]'
      );
      if (match) selectPkg(match);
    } else {
      var defaultCard = document.querySelector(
        ".onboard-pkg.is-selected[data-pkg]"
      );
      if (defaultCard) {
        selectPkg(defaultCard);
      } else {
        syncPackageFromDom();
        updateCheckoutSelected();
      }
    }

    applyStepVisibility();
    updateProgress();
    updateFooter();
    bindEvents();

    var first = getPanel(1);
    setPanelHeight(first);
    animateReveal(first);
    logFormSnapshot("init");
  }

  function fallback() {
    document.documentElement.classList.remove("js");
    if (!panels.length) return;
    panels.forEach(function (panel, i) {
      panel.hidden = i !== 0;
      panel.classList.toggle("is-active", i === 0);
      showPanelReveals(panel);
    });
  }

  document.documentElement.classList.add("js");

  try {
    init();
  } catch (err) {
    if (typeof console !== "undefined" && console.error) {
      console.error("Onboarding init failed:", err);
    }
    fallback();
  }
})();
